const UNSAFE_METHODS = ['POST', 'PUT', 'PATCH', 'DELETE'];

let unauthorizedHandler = null;

export const setUnauthorizedHandler = (handler) => {
  unauthorizedHandler = handler;
};

export const getCsrfToken = () => {
  const match = document.cookie.match(/(?:^|;\s*)csrftoken=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
};

export const http = async (url, options = {}) => {
  const { skipAuthRedirect, headers, ...rest } = options;
  const method = (rest.method || 'GET').toUpperCase();
  const finalHeaders = { ...(headers || {}) };

  if (UNSAFE_METHODS.includes(method)) {
    const token = getCsrfToken();
    if (token) {
      finalHeaders['X-CSRFToken'] = token;
    }
  }

  const response = await fetch(url, {
    ...rest,
    method,
    headers: finalHeaders,
    credentials: 'same-origin',
  });

  if (response.status === 401 && !skipAuthRedirect && unauthorizedHandler) {
    unauthorizedHandler();
  }

  return response;
};

export const httpJson = (url, options = {}) =>
  http(url, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
  });

export default http;
